import {Card, CardContent, CardHead} from "../atoms/Card";
import {CheckIcon, ExclamationIcon} from "@heroicons/react/outline";
import {useRouter} from "next/router";
import {NotionConnectionStatus} from "@app/core-app/app/data/profile";
import {Button, Text} from "@chakra-ui/react";
import {publicEnv} from "@app/core-app/pub-env";


type NotionConnectionProps = {
  notionConnection: NotionConnectionStatus | null | undefined
  onDisconnect: () => Promise<any>
}
export const NotionConnectionCard = ({notionConnection, onDisconnect}: NotionConnectionProps) => {
  const URL = "https://api.notion.com/v1/oauth/authorize"

  const fullURI = encodeURI(
    URL +
    `?client_id=${publicEnv.NOTION_CLIENT_ID}` +
    `&redirect_uri=${publicEnv.NOTION_REDIRECT_URL}/app/notion-connect` +
    "&response_type=code" +
    "&owner=user"
  )

  const isConnected = !!notionConnection?.accessToken
  const router = useRouter()
  return <Card>
    <CardHead justify>
      {isConnected ?
        <span className={"align-bottom"}><CheckIcon
          className={"h-6 w-6 inline text-green-700 mr-1"}/>Notion Connected</span> :
        <span className={"align-bottom"}><ExclamationIcon className={"h-6 w-6 inline text-orange-500 mr-1"}/> Connect Notion</span>
      }

      {!isConnected &&

        <Button
          variant={"solid"}
          size={"sm"}
          colorScheme={"blue"}
          onClick={() => {
            router.push(fullURI)
          }}
        >
          <Text mx={1}>Connect Notion</Text>
        </Button>
      }
      {isConnected &&
        <Button
          variant={"outline"}
          size={"sm"}
          colorScheme={"gray"}
          onClick={() => {
            onDisconnect()
          }}>
          <span>Disconnect</span>

        </Button>
      }
    </CardHead>
    <CardContent>
      {!isConnected && <p>Connect notion workspace and share access with NotionSender app.</p>}
      {isConnected &&
        <p className={""}>Connected to <span className={"text-black"}>{notionConnection.workspaceName}</span></p>}
      <p>Grant access to at least 1 page or database from Notion workspace to be able to create new databases.</p>
    </CardContent>

  </Card>
}
